import { useMemo } from 'react';
import { useJiraServiceManagementReportsNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/jsm-reports-resource/index.tsx';
import { getCustomReports } from './get-reports';
import type { UseCustomReportsResult } from './types';

/**
 * useCustomReports is also being consumed by the new Jira V4 navigation.
 * When making updates, ensure that the new navigation is supported/updated.
 * `jira/src/packages/navigation-apps/sidebar-nav4/jsm-project-menu`
 */
export const useCustomReports = (): UseCustomReportsResult => {
	const { data, loading } = useJiraServiceManagementReportsNavigation();
	const extractedData = useMemo(() => data && getCustomReports(data), [data]);
	return { data: extractedData, loading };
};
